import React from "react";
import "./Header.css";
import { Info, MapPin, FileText, SlidersHorizontal, BookOpen } from "lucide-react";
import SearchBox from "../SearchBox/SearchBox";

function Header({ activeView, onChangeView, onSelectFacility, onToggleFilterDrawer, hasActiveFilters }) {
  return (
    <header className="header">
      {/* Left spacer for centering */}
      <div className="header-left" />

      {/* Center navigation buttons */}
      <div className="header-buttons">
        <button
          className={`header-btn ${activeView === "about" ? "selected" : ""}`}
          onClick={() => onChangeView("about")}
        >
          <Info
            size={16}
            className="icon"
            stroke={activeView === "about" ? "#FFFFFF" : "#000000"}
          />
          About Us
        </button>

        <button
          id="onboarding-methodology-tab"
          className={`header-btn ${activeView === "methodology" ? "selected" : ""}`}
          onClick={() => onChangeView("methodology")}
        >
          <FileText
            size={16}
            className="icon"
            stroke={activeView === "methodology" ? "#FFFFFF" : "#000000"}
          />
          Methodology
        </button>

        <button
          className={`header-btn ${activeView === "stories" ? "selected" : ""}`}
          onClick={() => onChangeView("stories")}
        >
          <BookOpen
            size={16}
            className="icon"
            stroke={activeView === "stories" ? "#FFFFFF" : "#000000"}
          />
          Stories
        </button>

        <button
          className={`header-btn ${activeView === "markers" ? "selected" : ""}`}
          onClick={() => onChangeView("markers")}
        >
          <MapPin
            size={16}
            className="icon"
            stroke={activeView === "markers" ? "#FFFFFF" : "#000000"}
          />
          Map View
        </button>
      </div>

      {/* Right side - Search Box + Info Button (only show on map view) */}
      <div className="header-right">
        {activeView === "markers" && (
          <>
            <button
              className="header-filter-btn"
              onClick={onToggleFilterDrawer}
              title="Filter facilities"
            >
              <SlidersHorizontal size={20} />
              {hasActiveFilters && <span className="filter-active-dot" />}
            </button>
            <SearchBox onSelectFacility={onSelectFacility} />
          </>
        )}
      </div>
    </header>
  );
}

export default Header;
